<div class="lang-switch">
  @if (locale === "en") {
    <img
      class="ls-btn"
      width="25"
      height="17"
      alt="GR"
      [ngSrc]="'GR' | tuiFlag"
      (click)="setLocale('el')"
    />
  }
  @if (locale === "el") {
    <img
      class="ls-btn"
      width="25"
      height="17"
      alt="EN"
      [src]="'GB' | tuiFlag"
      (click)="setLocale('en')"
    />
  }
</div>
